module.exports = __webpack_public_path__ + "img/11_89.3169d561.png";